import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormInput, ActionWithPlus } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchToC, putToC } from '../../../api';
import { notify, getDictionary } from '../../../utils'

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {},
    new_latest_version_if: '',
    new_latest_version_and: '',
    new_latest_version_because: '',
    new_latest_version_then: ''
  }
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.requestNew = this.requestNew.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = 'toc') {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchToC(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => this.setState({ is_loading: false, data }))
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  request() {
    const params = this.getParams();
    putToC(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data.toc
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify('Error', err.message, 'error'))
  }
  requestNew(field = 'lastest_version_if', newValue = '') {
    if (newValue.trim().length === 0) {
      notify("error", "Fill the new IF statement field", "error");
      return;
    }
    let { toc } = this.state.data;
    toc.questions[field] = toc.questions[field].concat([{ answer: newValue }]);
    let newState = { data: { ...this.state.data, toc } };
    newState[`new_${field}`] = '';
    this.setState(newState);
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.toc || this.state.is_loading) return <span>Loading data...</span>
    let { toc } = this.state.data;
    return (
      <React.Fragment>
        <div>
          <p>{this.getText('statement_vision_question')}</p>
          <FormInput
            value={toc.questions.vision}
            onChange={(vision) => {
              let { toc } = this.state.data;
              toc.questions.vision = vision;
              this.setState({ data: { ...this.state.data, toc } })
            }}
            placeholder="" />
          <p>{this.getText('statement_assumptions_question')}</p>
          <FormInput
            value={toc.questions.assumptions}
            onChange={(assumptions) => {
              let { toc } = this.state.data;
              toc.questions.assumptions = assumptions;
              this.setState({ data: { ...this.state.data, toc } })
            }}
            placeholder="" />

          <p>{this.getText('statement_latest_version_question')}</p>

          <div>
            <p>IF</p>
            {toc.questions.latest_version_if.map((latest_version_if, index) => {
              return (
                <FormInput
                  style={{ marginTop: 8 }}
                  key={index}
                  value={latest_version_if.answer}
                  onChange={(answer) => {
                    let { toc } = this.state.data;
                    toc.questions.latest_version_if[index].answer = answer;
                    this.setState({ data: { ...this.state.data, toc } })
                  }}
                  placeholder="" />
              )
            })}
            <FormInput
              value={this.state.new_latest_version_if}
              onChange={(latest_version_if) => {
                this.setState({ new_latest_version_if: latest_version_if });
              }}
              style={{ marginTop: 8 }}
              placeholder="Write your new IF statement answer here" />
            <ActionWithPlus
              style={{ marginTop: 16 }}
              onClick={() => this.requestNew('latest_version_if', this.state.new_latest_version_if)}
              label="Save as new IF statement" />
          </div>

          <div>
            <p>AND</p>
            {toc.questions.latest_version_and.map((latest_version_and, index) => {
              return (
                <FormInput
                  style={{ marginTop: 8 }}
                  key={index}
                  value={latest_version_and.answer}
                  onChange={(answer) => {
                    let { toc } = this.state.data;
                    toc.questions.latest_version_and[index].answer = answer;
                    this.setState({ data: { ...this.state.data, toc } })
                  }}
                  placeholder="" />
              )
            })}
            <FormInput
              value={this.state.new_latest_version_and}
              onChange={(latest_version_and) => {
                this.setState({ new_latest_version_and: latest_version_and });
              }}
              style={{ marginTop: 8 }}
              placeholder="Write your new AND statement answer here" />
            <ActionWithPlus
              style={{ marginTop: 16 }}
              onClick={() => this.requestNew('latest_version_and', this.state.new_latest_version_and)}
              label="Save as new AND statement" />
          </div>

          <div>
            <p>THEN</p>
            {toc.questions.latest_version_then.map((latest_version_then, index) => {
              return (
                <FormInput
                  style={{ marginTop: 8 }}
                  key={index}
                  value={latest_version_then.answer}
                  onChange={(answer) => {
                    let { toc } = this.state.data;
                    toc.questions.latest_version_then[index].answer = answer;
                    this.setState({ data: { ...this.state.data, toc } })
                  }}
                  placeholder="" />
              )
            })}
            <FormInput
              value={this.state.new_latest_version_then}
              onChange={(latest_version_then) => {
                this.setState({ new_latest_version_then: latest_version_then });
              }}
              style={{ marginTop: 8 }}
              placeholder="Write your new THEN statement answer here" />
            <ActionWithPlus
              style={{ marginTop: 16 }}
              onClick={() => this.requestNew('latest_version_then', this.state.new_latest_version_then)}
              label="Save as new THEN statement" />
          </div>

          <div>
            <p>BECAUSE</p>
            {toc.questions.latest_version_because.map((latest_version_because, index) => {
              return (
                <FormInput
                  style={{ marginTop: 8 }}
                  key={index}
                  value={latest_version_because.answer}
                  onChange={(answer) => {
                    let { toc } = this.state.data;
                    toc.questions.latest_version_because[index].answer = answer;
                    this.setState({ data: { ...this.state.data, toc } })
                  }}
                  placeholder="" />
              )
            })}
            <FormInput
              value={this.state.new_latest_version_because}
              onChange={(latest_version_because) => {
                this.setState({ new_latest_version_because: latest_version_because });
              }}
              style={{ marginTop: 8 }}
              placeholder="Write your new BECAUSE statement answer here" />
            <ActionWithPlus
              style={{ marginTop: 16 }}
              onClick={() => this.requestNew('latest_version_because', this.state.new_latest_version_because)}
              label="Save as new BECAUSE statement" />
          </div>

        </div>

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}>
          SAVE
        </button>
      </React.Fragment >
    )
  }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/ToCFormularies.js